/**
 * Gateway storage is also served by the app edge (the dev server and the
 * production ingress both route /storage/ to the gateway), so a signed
 * download link can be fetched from this origin. Rewriting it to a path keeps
 * internal gateway ports (localhost:9080 in dev) out of the browser and
 * preserves the signed path and query. Other URLs pass through unchanged.
 */ export function sameOriginStorageUrl(raw) {
    let url;
    try {
        url = new URL(raw, window.location.href);
    } catch  {
        return raw;
    }
    return url.pathname.startsWith('/storage/v1/') ? `${url.pathname}${url.search}` : raw;
}
/**
 * Upload links are signed for the gateway host, so only the local gateway
 * (localhost:9080, unreachable from a host browser) is rewritten; deployed
 * gateways are reached directly, as before.
 */ export function localStorageUploadUrl(raw) {
    try {
        const { hostname } = new URL(raw, window.location.href);
        return hostname === 'localhost' || hostname === '127.0.0.1' ? sameOriginStorageUrl(raw) : raw;
    } catch  {
        return raw;
    }
}
